// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px"};